import React from 'react';
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-wrapper">
        <p>Produce &nbsp; by</p>
        <h2>HTML / SASS / REACT</h2>
        <p>Producer : Hayato Okamura</p>
      </div>
      </div>
  )
}

export default Footer;